/**
 * Angaben zur Anwendung für die Fußzeile: Version sowie die Verweise auf
 * Impressum und Datenschutz (im Container über IMPRINT_URL und PRIVACY_URL
 * gesetzt). Ohne Anmeldung abrufbar; eine Kopie im Gerät hält die Fußzeile
 * auch ohne Netz vollständig.
 */
import { useEffect, useState } from 'react';
import { api } from '../api/client.ts';

/** Antwort von /api/app-info. */
export interface AppInfo {
  readonly version: string;
  readonly imprintUrl: string | null;
  readonly privacyUrl: string | null;
}

/** Schlüssel der Gerätekopie. */
const STORAGE_KEY = 'kochbuch.app-info';

/** Liest die Gerätekopie. */
function readCached(): AppInfo | null {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    return raw === null ? null : (JSON.parse(raw) as AppInfo);
  } catch {
    return null;
  }
}

/** Angaben einmal je Seitenaufruf vom Server holen. */
let request: Promise<AppInfo> | null = null;

/** Angaben zur Anwendung; zuerst aus der Gerätekopie, dann frisch vom Server. */
export function useAppInfo(): AppInfo | null {
  const [info, setInfo] = useState<AppInfo | null>(readCached);
  useEffect(() => {
    let alive = true;
    request ??= api.get<AppInfo>('/api/app-info');
    request
      .then((fresh) => {
        try {
          window.localStorage.setItem(STORAGE_KEY, JSON.stringify(fresh));
        } catch {
          // Ohne Speicher eben ohne Kopie.
        }
        if (alive) {
          setInfo(fresh);
        }
      })
      .catch(() => {
        // Ohne Netz bleibt die Gerätekopie; beim nächsten Aufruf neu versuchen.
        request = null;
      });
    return () => {
      alive = false;
    };
  }, []);
  return info;
}
